import { tv } from 'tailwind-variants';

export const navTilesVariants = tv({
  slots: {
    container: ['col-span-12', 'order-2', 'w-full', 'md:mt-12'],
    wrapper: [
      'flex justify-center flex-wrap',
      'flex-col xm:flex-row',
      'gap-[5px]',
      'w-full',
      'mb-5 ml:mb-[5px]',
    ],
    tile: [
      'group',
      'flex-1',
      'bg-light-gray hover:bg-primary',
      'min-h-[45px]',
      'flex items-center justify-center gap-2.5',
      'py-[21.5px] md:py-[25px] px-4',
      'text-textPrimary hover:text-white',
      'transition-colors duration-[.15s] ease-in-out',
    ],
    icon: ['text-[26px] text-secondary', 'group-hover:text-inherit'],
    label: ['font-semibold text-lg md:text-base leading-[27px] md:leading-6'],
  },
  variants: {
    hideInMobile: {
      true: {
        tile: ['hidden xm:flex'],
      },
    },
  },
});
